import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/schedule/redux/actions';
import * as commonActions from '../../features/common/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { getKeyOfFrequnecy } from '../../common/utils/schedule-utils';
import ScheduleTaskRow from './ScheduleTaskRow';
import showAlert from '../../common/utils/alert';
import { BACKGROUND_TASK } from 'drapcode-constant';

export class DefaultPage extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    permission: false,
  };
  componentDidMount() {
    const { schedule, actions, match } = this.props;
    const { projectId, version } = match.params;
    actions.listSchedule({ projectId, version });
    actions.getPermissionFlags({ projectId });
    actions.loadProjectDetail({ projectId, version });
  }

  componentDidUpdate(prevProps) {
    console.log('here is DefaultPage bg-task', this.props);
    const { projectDetail } = this.props.common;
    if (prevProps.common.projectDetail !== projectDetail) {
      if (projectDetail && projectDetail.projectType) {
        const { projectType } = projectDetail;
      }
    }
  }

  handleDelete = (taskId) => {
    const { match, actions, history } = this.props;
    const { projectId, version } = match.params;
    const preConfirm = () => {
      actions.deleteSchedule({ projectId, taskId, version }).then((res) => {
        actions.listSchedule({ projectId, version });
      });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  handlePause = (taskId) => {
    const { match, actions, history } = this.props;
    const { projectId, version } = match.params;
    const preConfirm = () => {
      actions.pauseSchedule({ projectId, taskId, version }).then((res) => {
        actions.listSchedule({ projectId, version });
      });
    };
    showAlert('This will stop background job.', preConfirm, 'Yes, pause it!');
  };
  handleResume = (taskId) => {
    const { match, actions, history } = this.props;
    const { projectId, version } = match.params;
    const preConfirm = () => {
      actions.resumeSchedule({ projectId, taskId, version }).then((res) => {
        actions.listSchedule({ projectId, version });
      });
    };
    showAlert('This will restart background job.', preConfirm, 'Yes, restart it!');
  };

  parseCronExpression = (expression) => {
    if (!expression) {
      return '';
    }
    const interval = parser.parseExpression(expression);
    const fields = JSON.parse(JSON.stringify(interval.fields));
    return interval.next().toString();
  };

  render() {
    const { match, schedule } = this.props;
    const { projectId, version } = match.params;
    const { tasks, listSchedulePending, permissionFlags } = schedule;
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    return (
      <CommonPageComponent>
        <ParentContentCard
          icon="alarm"
          title="Background Task"
          headerLink={`/2.0/schedule/${version}/v/${projectId}/create`}
          headerTitle="Create Background Task"
          headerText="Create"
          isSearch={true}
        >
          {listSchedulePending ? (
            <div className="text-center">
              <CustomLoader loading={listSchedulePending} size="20px" color="#303453" />
            </div>
          ) : (
            <table className="table table-bordered table-hover table-sm table-word-break">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Frequency</th>
                  <th>Last Execution</th>
                  <th>Next Execution</th>
                  <th>Type</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((task) => (
                  <ScheduleTaskRow
                    key={task.uuid}
                    task={task}
                    projectId={projectId}
                    version={version}
                    handleDelete={this.handleDelete}
                    handlePause={this.handlePause}
                    handleResume={this.handleResume}
                    deleteFlag={permissionsArray.includes(BACKGROUND_TASK)}
                  />
                ))}
              </tbody>
            </table>
          )}
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    schedule: state.schedule,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
